module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-red-up.70b66c57.svg";